import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { LogIn, Wallet, Loader2 } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { AuthErrorMessage } from '../components/auth/AuthErrorMessage';
import { AuthPageShell } from '../components/auth/AuthPageShell';
import { AuthWalletHint } from '../components/auth/AuthWalletHint';
import { useAuth } from '../context/AuthContext';
import { useRedirectIfAuthenticated } from '../hooks/useRedirectIfAuthenticated';
import { AUTH_ACTIONS } from '../services/authService';

export function LoginPage() {
  const navigate = useNavigate();
  const { login, isConnecting, connectingAction, error, clearError } = useAuth();

  useRedirectIfAuthenticated();

  const handleLogin = () => {
    clearError();
    login()
      .then(() => navigate('/', { replace: true }))
      .catch(() => {});
  };

  const isLoggingIn = isConnecting && connectingAction === AUTH_ACTIONS.LOGIN;

  return (
    <AuthPageShell>
      <Card className="border-2 border-brand-red/20 shadow-xl">
        <CardHeader className="bg-red-50/40">
          <CardTitle className="flex items-center gap-2 text-brand-red">
            <LogIn className="h-5 w-5" />
            เข้าสู่ระบบ
          </CardTitle>
          <p className="mt-1 text-sm text-gray-600">
            เชื่อม Web3 wallet ที่ลงทะเบียนแล้วเพื่อเข้าใช้งาน
          </p>
        </CardHeader>
        <CardContent className="space-y-5">
          <AuthWalletHint title="MetaMask">
            กดปุ่มด้านล่างเพื่อเชื่อม wallet และลงชื่อยืนยันการเข้าสู่ระบบ
          </AuthWalletHint>

          <AuthErrorMessage message={error} />

          <Button
            size="lg"
            className="w-full"
            disabled={isConnecting}
            onClick={handleLogin}
          >
            {isLoggingIn ? (
              <>
                <Loader2 className="h-4 w-4 animate-spin" />
                กำลังเข้าสู่ระบบ...
              </>
            ) : (
              <>
                <Wallet className="h-4 w-4" />
                Login ด้วย Web3 Wallet
              </>
            )}
          </Button>

          <p className="text-center text-sm text-gray-600">
            ยังไม่มีบัญชี?{' '}
            <Link
              to="/register"
              className="font-semibold text-brand-red hover:underline"
            >
              สมัครสมาชิก
            </Link>
          </p>
        </CardContent>
      </Card>
    </AuthPageShell>
  );
}
